import ParticipantServiceFamily, {IParticipantServiceFamily} from "./ParticipantServiceFamily"

export interface ISkiSchoolServiceFamily extends IParticipantServiceFamily {

}

export default class SkiSchoolServiceFamily extends ParticipantServiceFamily implements ISkiSchoolServiceFamily {
    
    constructor(id: string) {
        super(id)
    }
}